import React from 'react';
import { Modal, ModalFooter } from '@/components/common';
import { UserDTO } from '@/models';

interface UserDeleteModalProps {
  isOpen: boolean;
  user: UserDTO | null;
  isSaving: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const UserDeleteModal: React.FC<UserDeleteModalProps> = ({
  isOpen,
  user,
  isSaving,
  onConfirm,
  onClose,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnBackdropClick={false}
      title="Delete User"
      footer={
        <ModalFooter
          onCancel={onClose}
          onConfirm={onConfirm}
          confirmText="Delete"
          confirmVariant="danger"
          isLoading={isSaving}
        />
      }
    >
      <p>
        Are you sure you want to delete user <strong>{user?.email}</strong>? This action
        cannot be undone.
      </p>
    </Modal>
  );
};
